document.addEventListener("DOMContentLoaded", () => {

    /************** Header scroll ******************/
    const header = document.querySelector("header");
    const hero = document.querySelector(".hero.home__hero");

    if (hero && header) {

        let triggerPoint = 0;

        function calculateTrigger() {
            const rect = hero.getBoundingClientRect();
            triggerPoint = rect.bottom + window.scrollY - 185;
        }

        function onScroll() {
            if (window.scrollY > triggerPoint) {
                header.classList.add("secondary");
            } else {
                header.classList.remove("secondary");
            }
        }

        window.addEventListener("scroll", onScroll);
        window.addEventListener("resize", () => {
            calculateTrigger();
            onScroll();
        });

        calculateTrigger();
        onScroll();

    }
    /******** handleHeaderTop ********/
    function handleHeaderTop() {

        if (window.innerWidth < 1100) {
            header.classList.remove("hide__top");
            return;
        }

        if (window.scrollY > 0) {
            header.classList.add("hide__top");
        } else {
            header.classList.remove("hide__top");
        }
    }

    window.addEventListener("resize", handleHeaderTop);
    window.addEventListener("scroll", handleHeaderTop);
    handleHeaderTop();


    /************** nos menus onglets ******************/
    const tabs = document.querySelectorAll('.menu_tab');
    const contents = document.querySelectorAll('.tab_content');

    tabs.forEach(tab => {

        tab.addEventListener('click', () => {

            const target = tab.dataset.tab;

            tabs.forEach(item => item.classList.remove('active'));
            contents.forEach(item => item.classList.remove('active'));

            tab.classList.add('active');

            const content = document.getElementById(target);

            if (content) {
                content.classList.add('active');
            }

        });

    });


    /****************** Animations ******************/
    function checkPositions() {

        const triggerPoint = window.innerHeight * 0.65;

        /***** ARTICLE IMAGES *****/
        document.querySelectorAll('.article__img').forEach(article => {

            const rect = article.getBoundingClientRect();

            const smallImg = article.querySelector('.small__img');
            const smallImg2 = article.querySelector('.small__img_2');
            const largeImg = article.querySelector('.large__img');

            if (rect.top <= triggerPoint && rect.bottom >= 0) {
                smallImg?.classList.add('anim');
                smallImg2?.classList.add('anim');
                largeImg?.classList.add('anim');
            }
        });

        /***** article *****/
        document.querySelectorAll('.article__content').forEach(article => {

            const rect = article.getBoundingClientRect();

            const articleTitle = article.querySelector('.title');
            const articleSubtitle = article.querySelector('.subtitle');
            const articleText = article.querySelector('.article__text');
            const articleBtn = article.querySelector('.btn.btn_secondary');

            if (rect.top <= triggerPoint && rect.bottom >= 0) {
                articleTitle?.classList.add('anim');
                articleSubtitle?.classList.add('anim');
                articleText?.classList.add('anim');
                articleBtn?.classList.add('anim');
            }
        });

        /***** intro *****/
        const intro = document.querySelector('.intro__text');

        if (intro) {

            const rect = intro.getBoundingClientRect();

            const introTitle = intro.querySelector('.title');
            const introSubtitle = intro.querySelector('.subtitle');
            const introText = intro.querySelector('.text');

            if (rect.top <= triggerPoint && rect.bottom >= 0) {
                introTitle?.classList.add('anim');
                introSubtitle?.classList.add('anim');
                introText?.classList.add('anim');
                intro.classList.add('anim');
            }
        }

        /***** hero *****/
        const heroContent = document.querySelector('.hero__content');

        if (heroContent) {

            const rect = heroContent.getBoundingClientRect();

            const preTitle = heroContent.querySelector('.hero_pretitle');
            const heroTitle = heroContent.querySelector('.hero_title');
            const heroText = heroContent.querySelector('.hero_text');
            const heroBtn = heroContent.querySelector('.btn');
            const heroBtnSecondary = heroContent.querySelector('.btn_secondary');

            if (rect.top <= triggerPoint && rect.bottom >= 0) {
                preTitle?.classList.add('anim');
                heroTitle?.classList.add('anim');
                heroText?.classList.add('anim');
                heroBtn?.classList.add('anim');
                heroBtnSecondary?.classList.add('anim');
            }
        }

        /***** Section nos menus *****/
        const imgWrapper1 = document.querySelector('.img__wrapper_1');
        const imgWrapper1img = document.querySelector('.img__wrapper_1 img');
        const imgWrapper2 = document.querySelector('.img__wrapper_2');
        const imgWrapper2img = document.querySelector('.img__wrapper_2 img');
        const contentWrapper = document.querySelector('.content__wrapper');

        if (imgWrapper1) {
            const rect = imgWrapper1.getBoundingClientRect();

            if (rect.top <= triggerPoint && rect.bottom >= 0) {
                imgWrapper1img?.classList.add('anim');
            }
        }
        if (imgWrapper2) {
            const rect = imgWrapper2.getBoundingClientRect();

            if (rect.top <= triggerPoint && rect.bottom >= 0) {
                imgWrapper2img?.classList.add('anim');
            }
        }
        if (contentWrapper) {
            const rect = contentWrapper.getBoundingClientRect();

            const subtitle = contentWrapper.querySelector('.subtitle');
            const title = contentWrapper.querySelector('.title');
            const menusWrapper = contentWrapper.querySelector('.menus__wrapper');
            const btn = contentWrapper.querySelector('.btn');
            const btnSecondary = contentWrapper.querySelector('.btn_secondary');

            if (rect.top <= triggerPoint && rect.bottom >= 0) {
                subtitle?.classList.add('anim');
                title?.classList.add('anim');
                menusWrapper?.classList.add('anim');
                btn?.classList.add('anim');
                btnSecondary?.classList.add('anim');
            }
        }

        /***** Section infos *****/
        const sectionInfos = document.querySelector('.section_infos');

        if (sectionInfos) {
            const rect = sectionInfos.getBoundingClientRect();

            if (rect.top <= triggerPoint && rect.bottom >= 0) {
                sectionInfos?.classList.add('anim');
            }
        }

        /***** Section bons cadeaux *****/
        const bonCadeaux = document.querySelector('.section__bons_cadeaux');

        if (bonCadeaux) {

            const bonCadeauxText = bonCadeaux.querySelector('.text__wrapper');

            const galerie1 = bonCadeaux.querySelector('.galerie__1');
            const galerie2 = bonCadeaux.querySelector('.galerie__2');
            const galerie3 = bonCadeaux.querySelector('.galerie__3');
            const galerie4 = bonCadeaux.querySelector('.galerie__4');

            if (bonCadeauxText) {

                const rect = bonCadeauxText.getBoundingClientRect();

                const title = bonCadeauxText.querySelector('.title');
                const subtitle = bonCadeauxText.querySelector('.subtitle');
                const text = bonCadeauxText.querySelector('.text');
                const btn = bonCadeauxText.querySelector('.btn');

                if (rect.top <= triggerPoint && rect.bottom >= 0) {
                    title?.classList.add('anim');
                    subtitle?.classList.add('anim');
                    text?.classList.add('anim');
                    btn?.classList.add('anim');
                }
            }

            [galerie1, galerie2, galerie3, galerie4].forEach(galerie => {
                if (!galerie) return;

                const rect = galerie.getBoundingClientRect();

                if (rect.top <= triggerPoint && rect.bottom >= 0) {
                    galerie.classList.add('anim');
                }
            });
        }

        /***** Section contact *****/
        const sectionContact = document.querySelector('.section__contact');

        if (sectionContact) {

        const contactImgWrapper1 = sectionContact.querySelector('.img__wrapper_1');
        const contactImgWrapper1img = sectionContact.querySelector('.img__wrapper_1 img');
        const contactImgWrapper2 = sectionContact.querySelector('.img__wrapper_2');
        const contactImgWrapper2img = sectionContact.querySelector('.img__wrapper_2 img');
        const contactTextWrapper = sectionContact.querySelector('.text_wrapper');

        if (contactImgWrapper1) {
            const rect = contactImgWrapper1.getBoundingClientRect();

            if (rect.top <= triggerPoint && rect.bottom >= 0) {
                contactImgWrapper1img?.classList.add('anim');
            }
        }
        if (contactImgWrapper2) {
            const rect = contactImgWrapper2.getBoundingClientRect();

            if (rect.top <= triggerPoint && rect.bottom >= 0) {
                contactImgWrapper2img?.classList.add('anim');
            }
        }
        if (contactTextWrapper) {
            const rect = contactTextWrapper.getBoundingClientRect();

            const subtitle = contactTextWrapper.querySelector('.subtitle');
            const title = contactTextWrapper.querySelector('.title');
            const text = contactTextWrapper.querySelector('.text');
            const btn = contactTextWrapper.querySelector('.btn');

                if (rect.top <= triggerPoint && rect.bottom >= 0) {
                    subtitle?.classList.add('anim');
                    title?.classList.add('anim');
                    text?.classList.add('anim');
                    btn?.classList.add('anim');
                }
            }
        }

        /***** Section form *****/
        const sectionForm = document.querySelector('.section__form');
        const contactFormWrapper = document.querySelector('.contact__form_wrapper');

        if (sectionForm) {
            const rect = sectionForm.getBoundingClientRect();

            if (rect.top <= triggerPoint && rect.bottom >= 0) {
                contactFormWrapper?.classList.add('anim');
            }
        }

        /***** section__bg_img *****/
        const sectionBgImg = document.querySelector('.section__bg_img');

        if (sectionBgImg) {
            const rect = sectionBgImg.getBoundingClientRect();

            const bgImg = sectionBgImg.querySelector('.bg__img');
            const title = sectionBgImg.querySelector('.title');
            const text = sectionBgImg.querySelector('.text');

            if (rect.top <= triggerPoint && rect.bottom >= 0) {
                bgImg?.classList.add('anim');
                title?.classList.add('anim');
                text?.classList.add('anim');

            }

        }

        /***** section__menus_onglets *****/
        const sectionMenuOnglets = document.querySelector('.section__menus_onglets');

        if (sectionMenuOnglets) {

            const container = sectionMenuOnglets.querySelector('.container');

                const rect = sectionMenuOnglets.getBoundingClientRect();

                if (rect.top <= triggerPoint && rect.bottom >= 0) {
                    container.classList.add('anim');
                }
        }


        /***** Section instagram *****/
        const sectionInstagram = document.querySelector('.section__instagram');
        const title = sectionInstagram.querySelector('.title');
        const subTitle = sectionInstagram.querySelector('.subtitle');
        const instagramGaleries = sectionInstagram.querySelector('.galeries');
        const instagramBtn = sectionInstagram.querySelector('.btn');

        if (sectionInstagram) {
            const rect = sectionInstagram.getBoundingClientRect();

            if (rect.top <= triggerPoint && rect.bottom >= 0) {
                title?.classList.add('anim');
                subTitle?.classList.add('anim');
            }
        }
        if (instagramGaleries) {
            const rect = instagramGaleries.getBoundingClientRect();

            if (rect.top <= triggerPoint && rect.bottom >= 0) {
                instagramGaleries?.classList.add('anim');
                instagramBtn?.classList.add('anim');
            }
        }

        /***** Section Parteanires *****/
        const sectionPartenaires = document.querySelector('.section__partenaires');

        if (sectionPartenaires) {
            const rect = sectionPartenaires.getBoundingClientRect();

            if (rect.top <= triggerPoint && rect.bottom >= 0) {
                sectionPartenaires?.classList.add('anim');
            }
        }

    }

    window.addEventListener("scroll", checkPositions);
    checkPositions();
});